import React from "react";
import { Box, Paper, Typography, Container } from "@mui/material";

const SavedCharts = () => {
  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "transparent",
          padding: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            borderRadius: 4,
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            backdropFilter: "blur(10px)",
          }}
        >
          <Typography
            variant="h4"
            gutterBottom
            sx={{ textAlign: "center", fontWeight: "bold", color: "#333" }}
          >
            Saved Charts
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: "1.2rem", textAlign: "center", color: "#555" }}
          >
            Thank you for visiting and taking the time to explore this project.
            Your feedback is always welcome, and I appreciate your interest in
            my work.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              textAlign: "center",
              color: "#555",
              marginTop: 2,
            }}
          >
            This page contains all the saved charts that you've viewed,
            including detailed information such as the predictions made and
            their accuracy. You can revisit any of your saved charts, open them
            for further insights, and provide valuable feedback on your
            experience.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              textAlign: "center",
              color: "#555",
              marginTop: 2,
            }}
          >
            Additionally, we’re excited to offer a unique feature: weekly
            insights based on your saved charts. Every week, a few interesting
            predictions will be highlighted among your charts—perfect for
            sharing or simply thrilling yourself with what the future might
            hold!
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              textAlign: "center",
              color: "#555",
              marginTop: 2,
            }}
          >
            This page is part of a larger vision and architectural plan. Feel
            free to share your thoughts or suggestions as we continue to build
            and improve this platform.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default SavedCharts;
